import React, { useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { SimpleLoading } from "../../pures";
import cellDetailSignatureRequest from "./cellDetailSignatureRequest";
import cellDetailAditionalServices from "./cellDetailAditionalService";
import SignatureRequestDetailView from "../../views/signature-request-detail/signature-request-detail.view";
import "./signature-request-panel.pure.css";

const SignRequestCellHeader = (props) => {
    const stylesSpanCellHeader = {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        color: "#123513",
        fontSize: "14px",
        fontFamily: "Quicksand, sans-serif",
    };
    const stylesIconCellHeader = {
        marginLeft: "4px",
    };

    let iconFilter = "k-i-arrows-swap";
    if (props.children !== false) {
        iconFilter =
            props.children[0].props.className === "k-icon k-i-sort-asc-sm"
                ? "k-i-sort-asc-sm"
                : "k-i-sort-desc-sm";
    }

    return (
        <span style={stylesSpanCellHeader} onClick={props.onClick}>
            {props.title}
            <i style={stylesIconCellHeader} className={`k-icon ${iconFilter}`}></i>
        </span>
    );
};

const SignatureRequestPanelGeneralHeaderOne = (props) => {
    return <span className="grid-header-one">{props.title}</span>;
};
const SignatureRequestPanelGeneralHeaderStyle = (props) => {
    return <span className="grid-headers">{props.title}</span>;
};

/* === Custom componente cells Solicitud for td elements of the Grid === */
const SignRequestCellSolicilud = (props) => {
    // let colorItem = "";

    // if (props.dataItem.signRequestStatusId) {
    //     if (props.dataItem.signRequestStatusId === 2) {
    //         colorItem = "#005EA0";
    //     } else if (props.dataItem.signRequestStatusId === 4) {
    //         colorItem = "#899232";
    //     } else if (props.dataItem.signRequestStatusId === 3) {
    //         colorItem = "#E63B31";
    //     } else if (props.dataItem.signRequestStatusId === 5) {
    //         colorItem = "#FF922C";
    //     } else {
    //         colorItem = "#000000";
    //     }
    // }

    // const cellItemStyles = {
    //     color: "#2C353C",
    //     fontSize: "16px",
    //     fontWeight: 550,
    //     borderBottom: "50px",
    //     textTransform: "capitalize",
    //     fontFamily: "Quicksand ",
    //     whiteSpace: "nowrap",
    //     textOverflow: "ellipsis",
    //     overflow: "hidden",
    // };

    return (
        <td>
            <span className="grid-cell-titles-margin-left">
                {props.dataItem[props.field]}
            </span>
        </td>
    );
};

/* === Custom componente for td elements of the Grid === */
const SignRequestCell = (props) => {
    const cellItemStyles = {
        color: "#4c4c4c",
        fontSize: "16px",
        fontWeight: 550,
        fontFamily: "Quicksand, sans-serif",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
    };
    return <td style={cellItemStyles}>{props.dataItem[props.field]}</td>;
};

const SignRequestCellDate = (props) => {
    return ( 
        <td>
            <span className="grid-cell-subtitles">
                {props.dataItem[props.field]}
            </span>
        </td>
    )
};

const SignRequestCellStatus = (props) => {
    const { t } = useTranslation();
    let statusName = "";

    switch (Number(props.dataItem.signRequestStatusId)) {
        case 2:
            statusName = t("signatureRequestPanelPure2.statusNamePending");
            break;
        case 3:
            statusName = t("signatureRequestPanelPure2.statusNameReject");
            break;
        case 4:
            statusName = t("signatureRequestPanelPure2.statusNameSigned");
            break;
        case 5:
            statusName = t("signatureRequestPanelPure2.statusNameCanceled");
            break;
        default:
            console.log("No se encontro el status de la solicitud");
    }

    return ( 
        <td>
            <span className="grid-cell-subtitles">
                {statusName}
            </span>
        </td>
    )
};

/* === Pure component Grid of SignatureRequestPanel === */
const SignatureRequestPanelPureQueriesValidations = (props) => {
    const { t } = useTranslation();

    const showFeatures = useMediaQuery("(min-width: 1280px)")
    const showLimitDate = useMediaQuery("(min-width: 1080px")
    const showCreatedDate = useMediaQuery("(min-width: 880px")
    const showStatus = useMediaQuery("(min-width: 680px")
    const is960 = useMediaQuery("(max-width:960px)");
    const is800 = useMediaQuery("(max-width:800px)");

    const scrollRef = useRef(null);

    const scrollHandler = useCallback(() => {
        if (!scrollRef.current) return;
    
        const scrollElement = scrollRef.current.querySelector('.k-grid-container'); 
        if (
          scrollElement.scrollTop + 10 >=
          scrollElement.scrollHeight - scrollElement.clientHeight
        ) {
            props.handleScrollRequest()
        }
      }, []);
    
      useEffect(() => {
        if (scrollRef.current) {
          const scrollElement = scrollRef.current.querySelector('.k-grid-container');
          if (scrollElement) {
            scrollElement.addEventListener('scroll', scrollHandler);
            return () => scrollElement.removeEventListener('scroll', scrollHandler);
          }
        }
      }, [scrollHandler]);

    const generalContainerBorderStyles = {
        paddingTop: "20px",
        borderTop: "1px solid #dedede",
        borderBottom: "1px solid #dedede",
    };
    
    const gridColumnNoRecordsStyle = {
        color: "#828282",
        fontSize: "17px",
        fontWeight: 600,
    };

    let { signatureRequests, total, filter, group, skip, take, sort } = props;
    const resultData = {
        data: signatureRequests,
        total,
    };
    const otherProps = {
        filter: filter ? filter : undefined,
        group: group ? group : undefined,
        sort: sort ? sort : [],
        skip,
        take,
    };

    const pagerSettings = {
        info: true,
        buttonCount: 5,
        type: "numeric",
        previousNext: true,
    }

    let heightGrid = '80px'
    if(resultData.data.length === 1){
        heightGrid = '107px'
    }else if(resultData.data.length === 2){
        heightGrid = '180px'
    }else if(resultData.data.length === 3){
        heightGrid = '250px'
    }else if(resultData.data.length === 4){
        heightGrid = '320px'
    }else if(resultData.data.length === 5){
        heightGrid = '394px'
    }else if(resultData.data.length >= 6){
        heightGrid = '462px'
    }else{
        heightGrid = '462px'
    }

    let widthCellName = '150px'
    let widthCellstatus = '40px'
    let widthCellDates = '50px'
    let widthCellFeatures = '40px'
    let widthCellAction = '60px'
    if(is960) widthCellAction = '80px'
    if(is800) widthCellAction = '40px'

    return (
        <div>
            {props.loading ? (
                <SimpleLoading />
            ) : (
                <div className={(resultData && resultData.data && resultData.data.length > 6) ? "digitalVaultView-data scroll" : ""} ref={scrollRef}>
                    <Grid
                        className="signature-table"
                        style={{ height: heightGrid }}
                        data={resultData}
                        {...otherProps}
                        sortable={true}
                        resizable={true}
                        reorderable={true}
                        pageable={false}
                        onDataStateChange={props.dataStateChange}
                    >
                        <GridColumn
                            field="name"
                            title={t("signatureRequestPanelPure2.request")}
                            minResizableWidth="auto"
                            sortable={false}
                            cell={SignRequestCellSolicilud}
                            headerCell={SignatureRequestPanelGeneralHeaderOne}
                            width={widthCellName}
                        />
                        {showStatus ?
                            <GridColumn
                                field="signRequestStatusId"
                                title={t("signatureRequestPanelPure2.status")}
                                sortable={false}
                                cell={SignRequestCellStatus}
                                headerCell={SignatureRequestPanelGeneralHeaderStyle}
                                width={widthCellstatus}
                                minResizableWidth={widthCellstatus}
                            />
                            : null
                        }

                        {showCreatedDate ?
                            <GridColumn
                                field="startDate"
                                title={t("signatureRequestPanelPure2.createdDate")}
                                textTransform="capitalize"
                                width={widthCellDates}
                                cell={SignRequestCellDate}
                                headerCell={SignRequestCellHeader}
                                minResizableWidth={widthCellDates}
                            />
                            : null
                        }

                        {
                            showLimitDate &&
                            <GridColumn
                                field="limitDate"
                                title={t("signatureRequestPanelPure2.expirationDate")}
                                textTransform="capitalize"
                                width={widthCellDates}
                                cell={SignRequestCellDate}
                                headerCell={SignRequestCellHeader}
                                minResizableWidth={widthCellDates}
                            />
                        }



                        {showFeatures ?
                            <GridColumn
                                field="additional"
                                title={t("signatureRequestPanelPure2.attributes")}
                                width={widthCellFeatures}
                                sortable={false}
                                cell={cellDetailAditionalServices(
                                    props.tooltipStampingTime,
                                    props.tooltipConservationMessage
                                )}
                                headerCell={SignatureRequestPanelGeneralHeaderStyle}
                                minResizableWidth={widthCellFeatures}
                            />
                            : null
                        }
                        <GridColumn
                            field="actions"
                            title={t("signatureRequestPanelPure2.actions")}
                            className="eyes-btn-grid"
                            minResizableWidth={widthCellAction}
                            width={widthCellAction}
                            sortable={false}
                            cell={cellDetailSignatureRequest({
                                selectedFilter: props.signRequestListId,
                                buttonClasss: props.buttonClass,
                                edit: props.edit,
                                seeDetail: props.seeDetail,
                                tracking: props.tracking,
                                tooltipDetail: props.tooltipDetail,
                                tooltipDelete: props.tooltipDelete,
                                toggleDialogDeleteRequest: props.toggleDialogDeleteRequest,
                                view: props.view,
                                visibilityIcon: true,
                                userMiFirmaId: props.userMiFirmaId,
                                killMe: props.killMe,
                                isHideTrash: props.isHideTrash,
                            })}
                            headerCell={SignatureRequestPanelGeneralHeaderStyle}
                        />
                        <GridNoRecords>
                            <span style={gridColumnNoRecordsStyle}>
                                {t("signatureRequestPanelPure2.notResults")}
                            </span>
                        </GridNoRecords>
                        {props.signatureRequestInEdit && (
                            <SignatureRequestDetailView
                                {...props}
                                dataItem={props.signatureRequestInEdit}
                                edit={props.edit}
                                onChangeSignatureRequest={props.onChangeSignatureRequest}
                            />
                        )}
                    </Grid>
                </div>
            )}
        </div>
    );
};
export { SignatureRequestPanelPureQueriesValidations as default };
